<template>
  <div>
    <ListToolbar
      :statistic="{
        value: getTotal,
      }"
      i18nLabel="map.tolldomains.active"
      :state="domainsListState"
      :statisticDataState="domainsListState"
      :paginationStart="getNavigationConfiguration.start"
      :elementsPerPage="getNavigationConfiguration.domainsPerPage"
      :numberOfElements="getTotal"
      :isLastPage="getNavigationConfiguration.isLastDomainsPage"
      @page-navigation-handler="pageNavigationHandler"
      @go-to-page="navigateToPage"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import ListToolbar from '@/components/common/ListToolbar/ListToolbar.vue';
import { INavigation, ITollDomainsState, store } from '@/store/modules/tollDomain/types';

@Component({
  components: {
    ListToolbar
  }
})
export default class DomainsListToolbar extends Vue {
  private themeColors: object;

  @store.Action
  private tollDomainNavigation!: (params: { direction: 'forward' | 'backward' }) => void;

  @store.Getter
  private getTollDomainsState!: ITollDomainsState;

  @store.Getter
  private getNavigationConfiguration!: INavigation;

  @store.Getter
  private getTotal!: number;

  @store.Action
  private updateNavigation!: (payload: INavigation) => void;

  private get domainsListState(): { [key: string]: boolean } {
    return {
      fetched: this.getTollDomainsState.fetched.domains,
      loading: this.getTollDomainsState.loading.domains,
      error: this.getTollDomainsState.error.domains
    };
  }

  private navigateToPage(page: number) {
    const current = this.getNavigationConfiguration;
    const next = {
      ...current,
      start: page * current.domainsPerPage - current.domainsPerPage
    };
    this.updateNavigation(next);
  }

  private pageNavigationHandler(direction: 'forward' | 'backward') {
    this.tollDomainNavigation({
      direction
    });
  }
}
</script>
